import React, { useMemo } from 'react';
import QueueContent from './components/QueueContent';
import AttendanceContent from './components/AttendanceContent';
import { Content } from './components/styled';
import { verifyRoles } from 'components/Authentication/VerifyRoles';

const ServicePanel = () => {
  const userLogin = useMemo(() => {
    const loginData = localStorage.getItem('login');
    return loginData ? loginData : null;
  }, []);

  const hasAccess = useMemo(() => {
    return verifyRoles(['ATTENDANT', 'TRAINEE', 'ATTENDANCE_PANEL']);
  }, []);

  if (!userLogin || !hasAccess) {
    return null;
  }

  return (
    <Content>
      <div className="queue">
        <QueueContent />
      </div>
      <div className="attendance">
        <AttendanceContent />
      </div>
    </Content>
  );
};

export default ServicePanel;
